import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';

export const systemShareAvailable = Boolean((Capacitor.isNativePlatform() && Share) || navigator.share);

export async function systemShare(url: string) {
  if (Capacitor.isNativePlatform() && Share) {
      Share.share({
      url
    });
  } else if (navigator.share) {
    navigator.share({ url });
  } else {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(url);
      alert('Link copied to clipboard!');
    } else {

    console.warn('System share is not available!');
    }
  }
}